// extracted by mini-css-extract-plugin
export default {"TableWrapper":"shared_TableWrapper__aYJ+9","CurrentPlan":"shared_CurrentPlan__EWnFB","Table":"shared_Table__XIBcT"};